module.exports = __webpack_public_path__ + "static/media/bp.7dd567b6.svg";